import React, { Children, useEffect, useState, } from "react";
import Select, {components} from "react-select";
import './reports.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from 'ag-grid-react';
import LoaderComponent from "../../../../libraries/loader/loader";
import { getReportGridDataFromServer, Fetchexecutequery } from '../../../../services/demo/medical-insurance/medicalInsuranceReportService';
import axios from "axios";
import excelIcon from '../../../../assets/images/excel.png';
import * as XLSX from 'xlsx';
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label } from 'semantic-ui-react'
import {port, port1} from "../../../../services/auth-service/authService";
import {baseUrl} from "../../../../services/common/credentials";
import { Component } from "ag-grid-community";


var local_host = baseUrl + port;
var local_host1 = baseUrl + port1;

function MedicalInsuranceReport() {

    const [selectedOptionsPolicyType, setSelectedOptionsPolicyType] = useState(undefined);
    const [selectedOptionsInsuranceCompany, setselectedOptionsInsuranceCompany] = useState(undefined);
    const [inputMonth, setInputMonth] = useState(undefined);
    const [hideResultGrid, setHideResultGrid] = useState(true);
    const [loaderOpen, setLoaderOpen] = useState(false);
    const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
    const [rowData, setRowData] = useState(undefined);
    const [paginationSize] = useState(15);
    const [companyname, setCompanyName] = useState([]);
    const [companyname1, setCompanyName1] = useState([]);
    const [clientname, setClientName] = useState([]);
    const [clientname1, setClientName1] = useState([]);
    const [modelcolumnnames, setmodelcolumnnames] = useState([]);
    const [modelcolumnnames1, setmodelcolumnnames1] = useState([]);
    const [modelcolumnnames2, setmodelcolumnnames2] = useState([]);
    const [modelcolumnnames3, setmodelcolumnnames3] = useState([]);
    const [inputYear, setInputYear] = useState(""); // State for year
    const [inputMonth1, setInputMonth1] = useState(""); // State for month

    const [compynames, setCompyNames] = useState([{}]);
    const [clientnames, setClientNames] = useState([{ value: "", label: "None" },]);
    const [reporttype, setreporttype] = useState({});
    const [isdisablecompanyname, setisdisablecompanyname] = useState(false);

        
    useEffect(() => {
        setLoaderOpen(false);
    }, []);

    const headers = modelcolumnnames1.length > 0 ? Object.keys(modelcolumnnames1[0]) : [];

    const ValueContainer = ({ children, getValue, ...props }) => {
        const maxToShow = 1;
        const length = getValue().length;
        const displayChips = React.Children.toArray(children).slice(0, maxToShow);
        const shouldBadgeShow = length > maxToShow;
        const displayLength = length - maxToShow;
    
        return (
            <components.ValueContainer {...props}>
                {!props.selectProps.inputValue && displayChips}
                {shouldBadgeShow && (
                    <div className="badge">
                        +{displayLength} more
                    </div>
                )}
                <div className="root"></div>
            </components.ValueContainer>
        );
    };
    
    const makeAPICall = async (url) => {
        try {
            setLoaderOpen(true);
            console.log(url);
            const response = await fetch(url);
            const data = await response.json();
			setmodelcolumnnames1((prevState) => [
            ...prevState,
            ...data]);
            //setRowData(json_data);
            
            setHideResultGrid(false);
            setLoaderOpen(false);
        }
        catch (e) {
            console.log(e);
            setLoaderOpen(false);
            setHideResultGrid(true);
        }
    }

    const Fetchinsurancecompanyinfo = (query) => {
        let payload = query
        console.log('payload---', payload)
    
        var FileUploadCredentials = Fetchexecutequery();
        console.log('FileUploadCredentials---',FileUploadCredentials[0])
    
        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
          .then(
            response => {
              console.log("Validate Credentials Response!!!", response);
              let data = response["data"];
              console.log("data",data)
              const dropdownOptions = data.map(item => ({
                  value: item.mis_insurance_company, // The value for the dropdown option
                  label: item.mis_insurance_company  // The label for the dropdown option
              }));
              console.log(dropdownOptions);
              setCompyNames(dropdownOptions);
              setLoaderOpen(false);
            //   fn(dropdownOptions);
            }
          )
          .catch((error) => {
            console.error("Error in database request:", error);
          });
    }

    const Fetchinsuranceclientinfo = (data) => {
        let payload = {
            query: `SELECT DISTINCT \`mis_client_name.1\` as client_name FROM medical_insurance.insurance_data WHERE ass_month = '${inputMonth1}' AND ass_year = '${inputYear}' AND mis_insurance_company IN ('${data}');`
        };
        console.log('payload---', payload)
    
        var FileUploadCredentials = Fetchexecutequery();
        console.log('FileUploadCredentials---',FileUploadCredentials[0])
    
        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
          .then(
            response => {
              console.log("Validate Credentials Response!!!", response);
              let data = response["data"];
              console.log("data",data)
              const dropdownOptions = data.map(item => ({
                  value: item.client_name, // The value for the dropdown option
                  label: item.client_name  // The label for the dropdown option
              }));
              console.log(dropdownOptions);
              setHideResultGrid(true);
              setClientNames(dropdownOptions);
              setLoaderOpen(false);
            //   fn(dropdownOptions);
            }
          )
          .catch((error) => {
            console.error("Error in database request:", error);
          });
    }

	const intColumnDefs3 = React.useMemo(() => {
    if (modelcolumnnames1?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(modelcolumnnames1[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),
      ];
	  console.log("header",intColumnDefs)
      setmodelcolumnnames(intColumnDefs);
      setLoaderOpen(false);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [modelcolumnnames1]);
  
  const intColumnDefs4 = React.useMemo(() => {
    if (modelcolumnnames2?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(modelcolumnnames2[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),
      ];
	  console.log("header",intColumnDefs)
      setmodelcolumnnames3(intColumnDefs);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [modelcolumnnames2]);
    

  const customStyles = {
    control: (base) => ({
        ...base,
        height: 30, // Adjust height as needed
        minHeight: 30,
        marginTop: 0,
        fontSize: 11,
        border: '1px solid #ccc', // Ensure you have a border
        boxShadow: 'none', // Remove any box shadow
        '&:hover': {
            border: '1px solid #aaa', // Change border color on hover
        },
    }),
    dropdownIndicator: (base) => ({
        ...base,
        padding: 4, // Adjust padding to fit within the border
        transition: 'all 0.2s', // Smooth transition for hover effects
    }),
    indicatorSeparator: () => ({
        display: 'none', // Optionally hide the separator
    }),
    menu: (base) => ({
        ...base,
        zIndex: 9999, // Ensure dropdown is on top
    }),
};



    // function getPolicytype(data) {
    //     setSelectedOptionsPolicyType(data);
    //     console.log(data);
    // }

    function getInsuranceCompany(data) {
        setselectedOptionsInsuranceCompany(data);
        console.log(data);
    }

    


   const makeAPICall3 = async (url) => {
    console.log('api call3');
    try {
        setLoaderOpen(true);
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const responseData = await response.json();
        console.log("data", responseData);

        var optionList3 = [];

        // Check if mis_insurance_company exists and is an array
        if (Array.isArray(responseData.mis_insurance_company)) {
            responseData.mis_insurance_company.forEach(item => {
                console.log('item', item);
                let object = {
                    value: item,
                    label: item
                };
                optionList3.push(object);
            });
        } else {
            console.log('mis_insurance_company is not an array:', responseData.mis_insurance_company);
        }

        setCompyNames(optionList3);
        setLoaderOpen(false);
        console.log(responseData);
    }
    catch (e) {
        console.log(e);
        setLoaderOpen(false);
    }
   }




    function getSetInputMonth(data) {
        setInputMonth(data);
        const [year, month] = data.split("-");
        setInputYear(year);  // Set the year
        setInputMonth1(parseInt(month, 10)); // Set the month
        console.log(data);
        setHideResultGrid(true);
        
    }

    const handleItemClick = (status, count) => {
        setmodelcolumnnames2([]);
        setmodelcolumnnames3([]);
        console.log(`Clicked on: ${status} with count: ${count}`);
        if (status === null){
            status = ''
        }
        setLoaderOpen(true);
        let payload;
        if (companyname1.length === 0 && clientname1.length === 0){
            payload = {query : `Select * FROM medical_insurance.insurance_data where ass_month= '${inputMonth1}' and ass_year='${inputYear}' and status = '${status}';`}
        } else if (clientname1.length === 0){
            payload = {query : `Select * FROM medical_insurance.insurance_data where mis_insurance_company in ${companyname1}
                 and ass_month= '${inputMonth1}' and ass_year='${inputYear}'and status = '${status}';`}
        } else {
            payload = {query : `Select * FROM medical_insurance.insurance_data where mis_insurance_company in ${companyname1} and \`mis_client_name.1\` in ${clientname1}
                 and ass_month= '${inputMonth1}' and ass_year='${inputYear}' and status = '${status}';`}
        }
        console.log('payload',payload)

        // let payload = {query : `Select * FROM medical_insurance.insurance_data where status = 'addition' and mis_insurance_company = 'united india insurance company limited' and \`mis_client_name.1\` = 'Master' and ass_month=8 and ass_year=2024;`}
        var FileUploadCredentials = Fetchexecutequery();
        
        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
          .then(
            response => {
              console.log("Validate Credentials Response!!!", response);
              let data = response["data"];          
              setmodelcolumnnames2((prevState) => [
                ...prevState,
                ...data]);
            setHideResultGrid(false);
            setLoaderOpen(false);
            //   fn(dropdownOptions);
            }
          )
          .catch((error) => {
            setLoaderOpen(false);
            setHideResultGrid(true);
            console.error("Error in database request:", error);
          });
    };

    function searchClick(event) {
        setmodelcolumnnames1([]);
        console.log("report",clientname1,companyname1,inputMonth1,inputYear)
        setLoaderOpen(true);
        // if (companyname === undefined) {
        //     alert("Please Select Report Type!!!");
        // }
        // else if(selectedOptionsPolicyType === undefined)
        // {
        //     alert("Please Select Policy Type!!!");
        // }
        // else if(selectedOptionsInsuranceCompany === undefined)
        // {
        //     alert("Please Select Insurance Company!!!");
        // }
        // else if (inputMonth === undefined)
        // {
        //     alert("Please Choose the Month!!!");
        // }
        let payload;
        if (companyname1.length === 0 && clientname1.length === 0){
            payload = {query : `Select distinct status,count(*) as count FROM medical_insurance.insurance_data where ass_month= '${inputMonth1}' and ass_year='${inputYear}' group by status order by status;`}
        } else if (clientname1.length === 0){
            payload = {query : `Select distinct status,count(*) as count FROM medical_insurance.insurance_data where mis_insurance_company in ${companyname1}
                 and ass_month= '${inputMonth1}' and ass_year='${inputYear}' group by status order by status;`}
        } else {
            payload = {query : `Select distinct status,count(*) as count FROM medical_insurance.insurance_data where mis_insurance_company in ${companyname1} and \`mis_client_name.1\` in ${clientname1}
                 and ass_month= '${inputMonth1}' and ass_year='${inputYear}' group by status order by status;`}
        }
        console.log('payload',payload)

        // let payload = {query : `Select * FROM medical_insurance.insurance_data where status = 'addition' and mis_insurance_company = 'united india insurance company limited' and \`mis_client_name.1\` = 'Master' and ass_month=8 and ass_year=2024;`}
        var FileUploadCredentials = Fetchexecutequery();
        
        axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
          .then(
            response => {
              console.log("Validate Credentials Response!!!", response);
              let data = response["data"];          
              setmodelcolumnnames1((prevState) => [
                ...prevState,
                ...data]);
            setHideResultGrid(false);
            // setLoaderOpen(false);
            //   fn(dropdownOptions);
            }
          )
          .catch((error) => {
            setLoaderOpen(false);
            setHideResultGrid(true);
            console.error("Error in database request:", error);
          });
    }
    

    function exportJsonToXLSX(data, sheetName, excelFileName) {
        try {
            var workBook = XLSX.utils.book_new();
            var workSheet = XLSX.utils.json_to_sheet(data, {
                skipHeader: false,
            });
            XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
            XLSX.writeFile(workBook, excelFileName);
            return true;
        }
        catch
        {
            return false;
        }
    }

    function exportToExcel() {
        let fileNameChange = "Report.xlsx";
        let sheetName = "sheet";

        let excelExportData = [];

        for (let i = 0; i < modelcolumnnames2.length; i++) {

            let data = {};
            for (let key in modelcolumnnames2[i]) {
                for (let j = 0; j < modelcolumnnames3.length; j++) {
                    if (key === modelcolumnnames3[j]["field"]) {
                        data[modelcolumnnames3[j]["headerName"]] = modelcolumnnames2[i][key]
                    }
                }
            }

            excelExportData.push(data);
        };

        exportJsonToXLSX(excelExportData, sheetName, fileNameChange);

    }



   

    const makeAPICall2 = async (url) => {
        console.log('api call');
        try {
            var optionList2 = [];
            setLoaderOpen(true);
            const response = await fetch(url);
            if (!response.ok) {
            throw new Error('Network response was not ok');
			}
			const responseData = await response.json();
			console.log("data", responseData);
            if (Array.isArray(responseData.client_name)) {
            responseData.client_name.forEach(item => {
                console.log('item', item);
                let object = {
                    value: item,
                    label: item
                };
                optionList2.push(object);
            });
			} else {
				console.log('mis_client_name is not an array:', responseData.mis_client_name);
			}
            setClientNames(optionList2);
            setLoaderOpen(false);
            
        }
        catch (e) {
            console.log(e);
            
        }
    }

    function getReportType1(data) {
        
        console.log(data);
        setHideResultGrid(true);
        if (data && data.value) {
            let url = '';
            console.log('companyname', data);
            let param = String(data.value)
            let param1 = String(inputMonth)
			let param2 = String(reporttype.value)
            url = local_host1+`/api/v2/medical_insurance/client_name/?com_name=${param}&&month=${param1}&&reporttype=${param2}`;  
            makeAPICall2(url);  
        }
    }

    function handleChange(data) {
        setmodelcolumnnames1([]);
        setCompanyName(data);
        console.log("data123",data);
        const formattedData = data.map(item => item.value).join("','");
        const result = `('${formattedData}')`; // Format it as desired
        console.log("formattedData",formattedData);
        console.log(result); // This will print: ('company1','company2')
        if (formattedData.length > 0){
            setCompanyName1(result);
        } else {
            setCompanyName1([])
        }
        Fetchinsuranceclientinfo(formattedData);
        
        // getReportType1(data);
        setHideResultGrid(true);
    }

    function handleChange1(data) {
        setmodelcolumnnames2([]);
        setmodelcolumnnames3([]);
        const formattedData1 = data.map(item => item.value).join("','");
        const result1 = `('${formattedData1}')`; // Format it as desired
        console.log(result1); // This will print: ('company1','company2')
        if (formattedData1.length > 0){
            setClientName1(result1)
        } else {
            setClientName1([])
        }
        setClientName(data);
        setHideResultGrid(true);
    }
	
	const reporttype_options = [
        //{ value: "edli", label: "EDLI"},
        //{ value: "ec", label: "EC"},
        { value: "gmc_gpa", label: "GMC & GPA"},
        //{ value: "gpa", label: "GPA"},
        //{ value: "gpl", label: "GPL"},
        //{ value: "health card", label: "Health Card"}
    ];

    const onchangereporttype = (data) =>{
        setreporttype(data);
        let payload = {query: `select distinct mis_insurance_company from medical_insurance.insurance_data where ass_month = '${inputMonth1}' and ass_year='${inputYear}';`}
        Fetchinsurancecompanyinfo(payload)
        setHideResultGrid(true);
        // if (data) {
        //     let url = '';
        //     let param = data.value;
        //     let param1 = String(inputMonth);
        //     console.log('data', param);
		// 	url = local_host1+`/api/v2/medical_insurance/company_name/?month=${param1}&&reporttype=${param}`;  
		// 	setisdisablecompanyname(false);
		// 	makeAPICall3(url);  
        // }
        
    }

    return (
        <>
            <div className="report-cardBox" style={{ fontSize: '11px' }}>
                <div className="" style={{ marginTop: "2px" }}>
                    <div>
                        <label id="underline_select" htmlFor="underline_select ">Month</label><br />
                        <input type="month" className="cardName filetype" style={{marginTop:'10px' }} onChange={(e) => { getSetInputMonth(e.target.value) }} />
                    </div>
                </div>
	 	    <div className="">
                    <div>
                        <label htmlFor="underline_select " style={{ left: '0px' }}>Reports Type</label> <br />
                        <div className="cardName">
                            <div className="dropdown-containers">
                                <Select
                                    options={reporttype_options}
                                    // placeholder="Select Report Type"
                                    value={reporttype}
                                    onChange={onchangereporttype}
                                    isSearchable={true}
                                    styles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="">
                    <div>
                        <label htmlFor="underline_select " style={{left: '0px' }}>Insurance Company Name</label> <br />
                        <div className="cardName">
                            <div className="dropdown-containers">
                                <Select
                                    clearable
                                    selection
                                    size='mini'
                                    hideSelectedOptions={false}
                                    components={{ ValueContainer}}
                                    options={compynames}
                                    // placeholder="Select Company Name"
                                    value={companyname}
                                    onChange={handleChange}
                                    isMulti
                                    isSearchable={true}
                                    styles={customStyles}
				                    // isDisabled={isdisablecompanyname}
                                />
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="">
                    <div>
                        <label htmlFor="underline_select "> Client Name</label> <br />
                        <div className="cardName">
                            <div className="dropdown-containers">
                                <Select
                                    clearable
                                    options={clientnames}
                                    selection
                                    // placeholder="Select Client Name"
                                    size='mini'
                                    value={clientname}
                                    isMulti
                                    onChange={handleChange1}
                                    hideSelectedOptions={false}
                                    components={{ ValueContainer}}
                                    isSearchable={true}
                                    styles={customStyles}
			                        isDisabled={isdisablecompanyname}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
                {companyname && inputMonth ?
                    <button className="btn" style={{ height: "30px", width: "80px", marginTop: "23px", backgroundColor: "#000055", color: "#ffffff" }} onClick={(e) => { searchClick(e) }}>Search</button>
                    : <button className="btn" disabled={true} style={{ height: "30px", width: "80px", marginTop: "23px", backgroundColor: "#000055", color: "#ffffff" }}>Search</button>
                }
            </div>
            <div>
            <div className="report" hidden={hideResultGrid} style={{ display: 'flex' }}>
                <div style={{ width: '20%' }}>
                    
                    <div className="report-layer">
                        <table className="data-table" style={{ width: '100%',height: '450px' }}>
                        <thead>
                            <tr>
                                {headers.map((header, index) => (
                                    <th key={index} className="data-table-header">{header}</th>
                                ))}
                            </tr>
                        </thead>

                            <tbody>
                                {modelcolumnnames1.map((item, index) => (
                                    <tr key={index} className="data-item" onClick={() => handleItemClick(item[headers[0]], item[headers[1]])}>
                                        {headers.map((header, i) => (
                                            <td key={i} className={`data-${header.toLowerCase()}`} style={{ height:'25px' }}> {/* Adjust width here */}
                                                {item[header]}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>
                </div>
                <div style={{ width: '80%', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
    <img
        src={excelIcon}
        alt="No Images"
        style={{ width: '40px', height: '40px', cursor: 'pointer', marginBottom: '10px' }}
        onClick={() => { exportToExcel() }}
        title="Export"
    />
    <div className="ag-theme-balham" style={{ height: '450px', width: '100%' }}>
        <AgGridReact
            columnDefs={modelcolumnnames3}
            rowData={modelcolumnnames2}
            paginationPageSize={paginationSize}
            pagination={true}
            animateRows={true}
        />
    </div>
</div>

            </div>
            </div>
            <LoaderComponent loaderOpen={loaderOpen} />
        </>
    )
}

export default MedicalInsuranceReport;